import { render } from "./Skills.component.vue?vue&type=template&id=b492eb6e"
import script from "./Skills.component.vue?vue&type=script&lang=js"
export * from "./Skills.component.vue?vue&type=script&lang=js"

import "./Skills.component.vue?vue&type=style&index=0&id=b492eb6e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__